import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	// 3
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st56: {
				opacity: 0.8,
			},
			st30: {
				fill: '#5994C9',
			},
			st25: {
				fill: '#FC5959',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="60.6767426" cy="17.5086575" />
				<path style={style.st2} d="M60,0H0v29h3.8718789c0,3,2.2385252,5,5,5h40.9238281
					c2.0810547,0,3.8881836-1.2339554,4.8815918-3.0625687c1.0894775-2.0056152,3.0285378-3.3693504,5.4715309-3.3693504
					 M60.1488304,27.5702438c2.4429932,0,4.6609612,1.3594093,5.7504387,3.3650246C66.8926773,32.7638817,68.792778,34,70.8738327,34
					h40.9980469c2.7614746,0,5-2,5-5H121V0H60 M50,21.2988281C50,25.5520687,46.5520668,29,42.2988281,29H19.7011719
					C15.4479322,29,12,25.5520687,12,21.2988281v-8.5976562C12,8.4479322,15.4479322,5,19.7011719,5h22.5976562
					C46.5520668,5,50,8.4479322,50,12.7011719V21.2988281z M109,21.2988281C109,25.5520687,105.5520706,29,101.2988281,29H78.7011719
					C74.4479294,29,71,25.5520687,71,21.2988281v-8.5976562C71,8.4479322,74.4479294,5,78.7011719,5h22.5976562
					C105.5520706,5,109,8.4479322,109,12.7011719V21.2988281z" />
				<g style={style.st56}>
					<rect x="9" y="3" style={style.st30} width="42" height="28" />
					<rect x="69" y="3" style={style.st25} width="42" height="27" />
				</g>
				<path style={style.st2} d="M60,0H0v29h3.8718789c0,3,2.2385252,5,5,5h40.9238281
					c2.0810547,0,3.8881836-1.2339554,4.8815918-3.0625687c1.0894775-2.0056152,3.0285378-3.3693504,5.4715309-3.3693504
					 M60.1488304,27.5702438c2.4429932,0,4.6609612,1.3594093,5.7504387,3.3650246C66.8926773,32.7638817,68.792778,34,70.8738327,34
					h40.9980469c2.7614746,0,5-2,5-5H121V0H60 M50,21.2988281C50,25.5520687,46.5520668,29,42.2988281,29H19.7011719
					C15.4479322,29,12,25.5520687,12,21.2988281v-8.5976562C12,8.4479322,15.4479322,5,19.7011719,5h22.5976562
					C46.5520668,5,50,8.4479322,50,12.7011719V21.2988281z M109,21.2988281C109,25.5520687,105.5520706,29,101.2988281,29H78.7011719
					C74.4479294,29,71,25.5520687,71,21.2988281v-8.5976562C71,8.4479322,74.4479294,5,78.7011719,5h22.5976562
					C105.5520706,5,109,8.4479322,109,12.7011719V21.2988281z" />
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	// 3
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="32.1586761" cy="9.2795887" />
				<g opacity="0.8">
					<rect x="4.77" y="1.59" fill="#5994C9" width="22.2600002" height="14.8400002" />
				</g>
				<g opacity="0.8">
					<rect x="36.5699997" y="1.59" fill="#FC5959" width="22.2600002" height="14.3100004" />
				</g>
				<path fill="#FFFFFF" d="M31.7999992,0H0v15.3699999h2.0520957c0,1.5899992,1.1864185,2.6500006,2.6500003,2.6500006h21.6896286
					c1.1029587,0,2.0607357-0.6539974,2.5872421-1.6231613c0.5774231-1.0629768,1.6051254-1.7857561,2.8999119-1.7857561
					M31.8788795,14.6122293c1.2947884,0,2.4703102,0.7204866,3.0477333,1.7834635
					c0.5265083,0.9691639,1.5335579,1.6243076,2.6365166,1.6243076h21.7289658c1.4635811,0,2.6500015-1.0600014,2.6500015-2.6500006
					h2.1879005V0h-32.329998 M26.5,11.2883787c0,2.2542171-1.827404,4.0816212-4.0816212,4.0816212h-11.976758
					c-2.2542171,0-4.0816207-1.827404-4.0816207-4.0816212V6.7316213c0-2.2542171,1.8274035-4.0816212,4.0816207-4.0816212
					h11.976758C24.672596,2.6500001,26.5,4.4774041,26.5,6.7316213V11.2883787z M57.7700005,11.2883787
					c0,2.2542171-1.827404,4.0816212-4.0816231,4.0816212h-11.976757c-2.2542152,0-4.0816193-1.827404-4.0816193-4.0816212
					V6.7316213c0-2.2542171,1.827404-4.0816212,4.0816193-4.0816212h11.976757c2.2542191,0,4.0816231,1.827404,4.0816231,4.0816212
					V11.2883787z" />
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	// 3
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} fill="none" cx="42.47372" cy="12.25606" />
				<path fill="#FFFFFF" d="M42,0H0v20.3h2.71032c0,2.1,1.56697,3.5,3.5,3.5h28.64668c1.45674,0,2.72173-0.86377,3.41711-2.1438
					c0.76263-1.40393,2.11998-2.35855,3.83007-2.35855 M42.10418,19.29917c1.7101,0,3.26268,0.95159,4.02531,2.35552
					C46.82487,22.93472,48.15495,23.8,49.61168,23.8h28.69864c1.93303,0,3.5-1.4,3.5-3.5H84.7V0H42 M35,14.90918
					C35,17.88645,32.58645,20.3,29.60918,20.3H13.79082C10.81355,20.3,8.4,17.88645,8.4,14.90918V8.89082
					C8.4,5.91355,10.81355,3.5,13.79082,3.5h15.81836C32.58645,3.5,35,5.91355,35,8.89082V14.90918z M76.3,14.90918
					c0,2.97727-2.41356,5.39082-5.39082,5.39082H55.09082C52.11355,20.3,49.7,17.88645,49.7,14.90918V8.89082
					C49.7,5.91355,52.11355,3.5,55.09082,3.5h15.81836C73.88644,3.5,76.3,5.91355,76.3,8.89082V14.90918z" />
				<g opacity="0.8">
					<rect x="6.3" y="2.1" fill="#5994C9" width="29.4" height="19.6" />
				</g>
				<g opacity="0.8">
					<rect x="48.3" y="2.1" fill="#FC5959" width="29.4" height="18.9" />
				</g>
				<path fill="#FFFFFF" d="M42,0H0v20.3h2.71032c0,2.1,1.56697,3.5,3.5,3.5h28.64668c1.45674,0,2.72173-0.86377,3.41711-2.1438
					c0.76263-1.40393,2.11998-2.35855,3.83007-2.35855 M42.10418,19.29917c1.7101,0,3.26268,0.95159,4.02531,2.35552
					C46.82487,22.93472,48.15495,23.8,49.61168,23.8h28.69864c1.93303,0,3.5-1.4,3.5-3.5H84.7V0H42 M35,14.90918
					C35,17.88645,32.58645,20.3,29.60918,20.3H13.79082C10.81355,20.3,8.4,17.88645,8.4,14.90918V8.89082
					C8.4,5.91355,10.81355,3.5,13.79082,3.5h15.81836C32.58645,3.5,35,5.91355,35,8.89082V14.90918z M76.3,14.90918
					c0,2.97727-2.41356,5.39082-5.39082,5.39082H55.09082C52.11355,20.3,49.7,17.88645,49.7,14.90918V8.89082
					C49.7,5.91355,52.11355,3.5,55.09082,3.5h15.81836C73.88644,3.5,76.3,5.91355,76.3,8.89082V14.90918z" />
			</g>
		);
	}
}

function ThreeD(props) {
	const glasses = {
		Cat,
		Tortoise,
		Chicken,
	};

	const ThisThreeD = glasses[props.petType.name] || Cat;

	if (_.isUndefined(ThisThreeD)) {
		return null;
	}

	return <ThisThreeD {...props} />;
}

export default ThreeD;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Glasses/ThreeD.js